export default {

	init() {
		document.addEventListener("DOMContentLoaded", this.bindEvents);
	},

	bindEvents() {
		$('.btn-toggle').on('click', function(e) {
			e.preventDefault();

			$(this).toggleClass('is-active');
		});
	},

}
